import { render, staticRenderFns } from "./bottomRightChart.vue?vue&type=template&id=475e75b4"
import script from "./bottomRightChart.vue?vue&type=script&lang=js"
export * from "./bottomRightChart.vue?vue&type=script&lang=js"
import style0 from "./bottomRightChart.vue?vue&type=style&index=0&id=475e75b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports